import { AppHeaderBackButton } from '@ace-clublabs/shared-component-library';
import { ClubHelper } from '@ace-clublabs/payments-helper';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AutopayEnrollmentForm from '../components/AutopayEnrollmentForm';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { mapMembershipLevelForTagging } from '@lib/shared';
import { UtagHelper } from '../utils/utagHelper';
import { loginOnClick } from '../utils/urlHelper';
import { AppFlow } from '@lib/types';
import { ClubCodes } from '@ace-clublabs/payment-types';

const AutopayEnrollmentPage: React.FC = () => {
  const navigate = useNavigate();
  const onClickBack = () => navigate(-1);
  const [membershipLevel] = useGlobalState('membershipLevel');
  const [autoPay] = useGlobalState('autoPay');
  const [amountDue] = useGlobalState('amountDue');
  const [campaignCode] = useGlobalState('campaignCode');
  const [appFlow] = useGlobalState('appFlow');
  const [, setAutoPayEnroll] = useGlobalState('autoPayEnrolled');
  const { eligible, discount } = autoPay || {};
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [clubCode] = useGlobalState('clubCode');
  const [tagging, setIsTagging] = useState(true);

  useEffect(() => {
    const mem_level = mapMembershipLevelForTagging(membershipLevel);

    const tags =
      appFlow === AppFlow.AUTOPAY
        ? {}
        : {
            mem_autopaycampaign: eligible && discount ? 'autopay required' : 'autopay not required',
            bill_status: amountDue > 0 ? 'due' : 'not due',
            campaigncodemr: campaignCode,
            mem_autopay: `${eligible}`,
          };
    UtagHelper.tag({
      ...UtagHelper.CommonTaggingValues(appFlow),
      ...tags,
      club: ClubHelper.getClubAcronym(clubCode as ClubCodes),
      page: UtagHelper.Pages(appFlow).autoPay,
      mem_level,
    });

    setIsTagging(false);
  }, []);

  const onClickNext = (values: any) => {
    const autoPayEnrolled = values?.selections;
    setAutoPayEnroll(autoPayEnrolled);
    navigate(Pages.UpdateEmails);
  };

  const onClickCancel = () => {
    loginOnClick(clubCode);
  };

  if (tagging) {
    return <></>;
  }

  return (
    <>
      {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={onClickBack} />}
      <AutopayEnrollmentForm onClickNext={onClickNext} onCancel={onClickCancel} />
    </>
  );
};

export default AutopayEnrollmentPage;
